import { Table } from "antd";
import { DataType } from "../../../models/interface/license.interface";
import { Columns } from "./Column";
import PaginationComponent from "./Pagination";

const App = ({ data, total }: { data: DataType[]; total: number }) => {
  return (
    <>
      <Table<DataType> columns={Columns} dataSource={data} pagination={false} />
      <PaginationComponent total={total} />
    </>
  );
};

export default App;
